// extracted by mini-css-extract-plugin
export default {"helpText":"NhEQqyW7MaFJRaCJsdsT","contact":"n_Z5yPjWH9EftReKhwof","details":"X5GXzAJYFJjnApCPsuVg","bottomborder":"l_iqZMdA9SmBmoL2enqH"};